
import { $$Dic, ModalHelper, bootbox, avatar, B2bToast, validateEmail } from "../../B2bTools";
import { createApp, watch } from "vue";
import { may } from "../composant/b2bLangue";
import hash from "../../hash";
import html from "./brandname.html";
import htmlBrandnameEdit from "./brandname@edit.html";
import htmlBrandnameCustomer from "./brandname@customer.html";
import htmlBrandnameOrderdepartment from "./brandname@orderdepartment.html";
import htmlBrandnameReps from "./brandname@reps.html";
import b2bTypeahead from "../composant/b2bTypeahead";
import cardUsers from "../composant/cardUsers";

const js = ({
    url: function (echangeur) {
        console.log(echangeur.hash)
        echangeur.addAction('b2b.codification.select', { classe: "orderdepartment" }, '', 'orderdepartment');  
        echangeur.addAction('b2b.brandname.edit', echangeur.hash, '', 'form');
        echangeur.addAction('b2b.env.get', echangeur.hash, '', 'universe');
        echangeur.addAction('groupe.listWholesale', echangeur.hash, '', 'wholesaleGroups');
        echangeur.addAction('utilisateur.profilList', echangeur.hash, 'form', 'profils');
        //echangeur.addAction('user.liste', {}, 'form', 'users');
    },
    onLoad: function (echangeur) {
        let THIS = this;
        const form = echangeur.form;
        // const wholesaleGroups = echangeur.wholesaleGroups;
        const _id = form._id;
        const orderdepartment = echangeur.orderdepartment.rows;
        //
        const $$dic = new $$Dic(echangeur.form.$$dic);
        delete form.$$dic;

        //
        const app = createApp({
            data: () => ({
                saisie: echangeur.form,
                showMarkets: true,
                datas: form,
                // groups: wholesaleGroups,
                orderdepartment: orderdepartment,
                profils: echangeur.profils.rows,
                pricat : (form.pricat===true),
                pricatfilename : form.pricatfilename,
                // isEdi:   echangeur.isEdi,
                envEdi : (echangeur.universe.env.edi === true),
                //users: echangeur.users.rows
            }),

            components: {
                'card-users': cardUsers
            },

            methods: {
                back() {
                    hash.fin();
                },

                toOrderdepartment(k) {
                    const option = orderdepartment.find(u => (u.k == k));
                    return (option) ? option.v : k;
                },

                toBuyer(k) {
                    return $$dic.utilisateur(k);
                },

                toProfil(k) {
                    let r = this.profils.find(el => (el.k == k));
                    return (r) ? r.v : k;
                },
                pretenom(item) {
                    if (!may("PRETENOM")) return false;
                    const buyer = this.toBuyer(item)
                    if (buyer.profil == "dmk-buy") return true;
                    return false;
                },
                connectas(item) {
                    const url = "" + window.location;
                    const a = url.split("?")[0];
                    const b = a.split("#")[0];
                    const c = b + "?client=" + encodeURI(item) + "#";
                    window.location.assign(c);
                },
                async gouserpage(k) {
                    let response = await THIS.rest('user.liste', {}, 'form', 'users');
                    const item = response.rows.find(el => (el.k === k))._id;
                    THIS.hashLance("userDetail", { _id: item });
                },

                toGroup(k) {
                    const sdoc = echangeur.wholesaleGroups.rows.find(u => (u.k == k));
                    return (sdoc) ? sdoc.v : k;
                },

                toReps(val) {
                    // if (val) {
                    //     const checkUser = val.map(x => this.users.find(el => {
                    //         if (el.k === x) {
                    //             return el.k === x
                    //         } else {
                    //             return x
                    //         }
                    //     }))
                    //     return checkUser// ? checkUser.displayname : "-"//.join(', ') : "-"
                    // } else {
                    //     return ""
                    // }
                    return (val) ? val.map(x => x).join(', ') : ''
                },

                deleteBrandName() {
                    let thisVue = this;
                    bootbox.confirm(
                        {
                            title: 'Remove Brand Name',
                            message: `Are you sure to delete <b> ${this.datas.v} </b> ?`
                        },
                        async function () {
                            let result = await THIS.rest("b2b.brandname.del", { "_id": _id }, {});
                            if (result.ok) {
                                B2bToast(`${thisVue.datas.v} deleted`, 'success')
                                THIS.fin();
                            }
                        })
                },


                getInitial(user) {
                    /*   if (user.initial) return user.initial;
                      let txt = user.displayname.split(" ");
                      let initial = "";
                      if (txt.length > 1) {
                          initial = txt[0].charAt(0) + txt[1].charAt(0);
                      } else {
                          initial = txt[0].charAt(0) + txt[0].charAt(1);
                      }
                      return initial.toUpperCase(); */
                    return user.replace('.', '').substring(0, 2) // pour faire jolie
                },

                getColor(user) {
                    let a = user.role || user.profil;
                    return avatar.color(a);
                },

                async headerEdit() {
                    let tms = new Date().getTime()+"";
                    console.log("tms"+tms)
                    const thisParent = this;
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                tms:tms,
                                datas: thisParent.saisie, 
                                saisie: '',
                                pricat: false,
                                pricatfilename:"",
                                envEdi: false,
                                error: {
                                    v: ""
                                }
                            }
                        },
                        methods: {
                            close: function () {
                                ModalHelper.hide();
                            },
                            reset() {
                                this.error.v = false
                            },
                            async save() {
                                const thisVue = this;
                                this.reset()
                                function nbe(object) {
                                    let nb = 0;
                                    for (let key in object) if (object[key]) nb++;
                                    return nb;
                                }

                                const form = {
                                    "v": this.saisie,
                                    "pricat": this.pricat,  
                                    "pricatfilename": this.pricatfilename,
                                } 
                                if (!form.v) this.error.v = "Required"

                                if (!nbe(this.error)) {
                                    const result = await THIS.rest("b2b.brandname.saveHeader", { "_id": _id }, form);
                                    thisParent.pricat = result.doc.pricat;
                                    thisParent.pricatfilename= result.doc.pricatfilename;
                                    result.doc;
                                    this.close()
                                }

                            },
                        },
                        mounted() {
                            this.saisie = this.datas.v;
                            this.envEdi = thisParent.envEdi;
                            if(this.envEdi) this.pricat = thisParent.pricat; 
                            if(this.envEdi) this.pricatfilename = thisParent.pricatfilename; 

                            ModalHelper.show(async function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlBrandnameEdit).container);
                },

                async customerEdit() {
                    const thisParent = this;
                    const form = await THIS.rest("b2b.brandname.editClients", { _id });

                    //
                    let iKey = 0;
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                sid: "clients", 
                                rows: form,
                            }
                        },
                        components: {
                            "type-ahead": b2bTypeahead,
                        },
                        methods: {
                            deleteRow(i) {
                                this.rows.splice(i, 1);
                            },
                            close: function () {
                                ModalHelper.hide();
                            },
                            typeaheadCustomer() {
                                return async function (key) {
                                    const rows = await THIS.rest("b2b.customer.typeahead", { k: key, limit: 10 })
                                    return rows.map(u => (
                                        { k: u.k, av: u.v, v: '(' + u.k + ') ' + u.v }
                                    ));
                                }
                            },
                            selectCustomer(item) {
                                let exists = this.rows.find(u => (u.k == item.k));
                                //
                                if (!exists) {
                                    this.rows.push({ k: item.k, v: item.av, vv: item.av, key: "key" + iKey++ })
                                }
                            },

                            async saveForm(e) {
                                e.preventDefault();
                                let nbError = 0;
                                if (!nbError) {
                                    const data = {
                                        sid: this.sid,
                                        clients: this.rows.map(u => ({ k: u.k, vv: u.vv || u.v })),
                                    }
                                    const result = await THIS.rest("b2b.brandname.saveClients", { _id, sid: "clients" }, data);
                                    thisParent.saisie = result.doc;
                                    this.close();
                                }

                            },
                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlBrandnameCustomer).container);
                },






                orderdepartmentDelete(sdoc) {
                    const thisParent = this;
                    let total = sdoc.buyers.length
                    if (total == 0) {
                        bootbox.confirm(
                            {
                                title: 'Remove orderdepartment',
                                message: `Are you sure to delete <b> ${this.toOrderdepartment(sdoc.orderdepartment)} </b> ?`
                            },
                            async function () {
                                const retour = await THIS.rest("b2b.brandname.deleteOrderdepartment", { _id, orderdepartment: sdoc.orderdepartment });
                                thisParent.saisie = retour.doc;
                            })
                    } else {
                        bootbox.alert(
                            {
                                title: 'Warning',
                                message: `There are ${total} user(s) left in <b> ${this.toOrderdepartment(sdoc.orderdepartment)} </b>`
                            })
                    }
                },

                async orderdepartmentEdit(itemSelected) {
                    const thisParent = this;
                    let form;
                    if (itemSelected) {
                        form = await THIS.rest("b2b.brandname.editOrderdepartments", { _id, orderdepartment: itemSelected.orderdepartment });
                    } else {
                        form = { orderdepartment: "", rows: [], team: '', group: '' }
                    }
                    let objMarkets = {}
                    thisParent.saisie.orderdepartments.forEach(u => {
                        if (u.orderdepartment != form.orderdepartment) objMarkets[u.orderdepartment] = u
                    })

                    let choixPossible = [];
                    orderdepartment.map(u => {
                        if (!objMarkets[u.k]) choixPossible.push(u);
                    })

                    let iKey = 0;
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                isnew: (!form.orderdepartment),
                                orderdepartment: form.orderdepartment,
                                rows: form.rows,
                                team: form.team,
                                // v: form.v,
                                options: {
                                    orderdepartment: choixPossible,
                                    groups: echangeur.wholesaleGroups,
                                },
                                errorSid: false,
                                isCreateBuyer: false,

                                // Pour la création d'un buyer
                                saisie: {
                                    displayname: '',
                                    email: '',
                                    profil: 'dmk-buy',
                                    title: '',
                                    initial: '',
                                    notif: true,
                                },
                                errors: {
                                    message: null,
                                    email: null,
                                    displayname: null,
                                    profil: null,
                                    title: null,
                                },

                            }
                        },
                        components: {
                            "type-ahead": b2bTypeahead,
                        },
                        methods: {
                            toTitle() {
                                if (this.isCreateBuyer) return "Create Buyer";
                                if (this.isnew) return "Add Order department";
                                return "Edit Order department";
                            },
                            deleteRow(i) {
                                this.rows.splice(i, 1);
                            },
                            close: function () {
                                ModalHelper.hide();
                            },
                            toOrderdepartment(k) {
                                const option = orderdepartment.find(u => (u.k == k));
                                return (option) ? option.v : k;
                            },
                            toGroup(k) {
                                const sdoc = echangeur.wholesaleGroups.rows.find(u => (u.k == k));
                                return (sdoc) ? sdoc.v : k;
                            },
                            typeaheadBuyer() {
                                return async function (key) {
                                    const rows = await THIS.rest("b2b.brandname.typeaheadBuyer", { k: key, limit: 10 })
                                    return rows.map(u => (
                                        { k: u.k, initial: u.initial, title: u.title, displayname: u.displayname, email: u.email, v: u.displayname + " (" + u.email + ")" }
                                    ));
                                }
                            },
                            selectuser(item) {
                                let exists = this.rows.find(u => (u.k == item.k));
                                if (!exists) {
                                    $$dic.addUtilisateur({ k: item.k, initial: item.initial, title: item.title, v: item.displayname, email: item.email })
                                    this.rows.push({ k: item.k, initial: item.initial, title: item.title, v: item.displayname, email: item.email, key: "key" + iKey++ })
                                }
                            },

                            async saveForm(e) {
                                e.preventDefault();
                                let nbError = 0;

                                this.errorSid = false;
                                if (!this.orderdepartment) {
                                    this.errorSid = true;
                                    nbError++;
                                }

                                if (!nbError) {
                                    const data = {
                                        orderdepartment: this.orderdepartment,
                                        buyers: this.rows.map(u => u.k),
                                        team: this.team,
                                    }
                                    const result = await THIS.rest("b2b.brandname.saveOrderdepartments", { _id, orderdepartment: this.orderdepartment }, data);
                                    thisParent.saisie = result.doc;

                                    //for (const k in thisParent.saisie.buyer) $$dic.utilisateur(k)

                                    this.close();
                                }

                            },

                            createBuyer() { this.isCreateBuyer = true },
                            closeBuyer() {
                                this.isCreateBuyer = false;
                                this.errors = {}
                                this.saisie = {
                                    displayname: '',
                                    email: '',
                                    profil: 'dmk-buy',
                                    title: '',
                                    initial: '',
                                    notif: true,
                                }
                            },

                            async saveBuyer() {

                                function nbe(objet) {
                                    let nb = 0;
                                    for (let key in objet) if (objet[key]) nb++;
                                    return nb;
                                }

                                this.errors = {}

                                if (!this.saisie.displayname) this.errors.displayname = true;
                                if (!this.saisie.email) {
                                    this.errors.email = true;
                                } else if (!validateEmail(this.saisie.email)) {
                                    this.errors.email = true;
                                    this.errors.messEmail = "Invalid email ";
                                }

                                // if (!this.saisie.initial) this.errors.initial = true;

                                if (!nbe(this.errors)) {
                                    let result = await THIS.rest("user.createUser", { _id: "_new" }, this.saisie);

                                    if (result.errors) {
                                        this.errors.message = result.errors;
                                    } else {
                                        const id = result._id
                                        const rows = await THIS.rest("b2b.brandname.typeaheadBuyer", { k: this.saisie.email, limit: 10 })
                                        this.selectuser(rows.map(u => (
                                            { k: u.k, initial: u.initial, title: u.title, displayname: u.displayname, email: u.email, v: u.displayname + " (" + u.email + ")" }
                                        )).find(u => (u.k == id)))
                                        this.closeBuyer()
                                    }
                                }
                            },
                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlBrandnameOrderdepartment).container);
                },


                async repsEdit(itemSelected) {
                    const thisParent = this;
                    let form;
                    if (itemSelected) {
                        form = await THIS.rest("b2b.brandname.editReps", { _id, orderdepartment: itemSelected.orderdepartment });
                    } else {
                        form = { orderdepartment: "", rows: [], team: '', group: '' }
                    }
                    let objMarkets = {}

                    thisParent.saisie.orderdepartments.forEach(u => {
                        if (u.orderdepartment != form.orderdepartment) objMarkets[u.orderdepartment] = u
                    })

                    let choixPossible = [];
                    orderdepartment.map(u => {
                        if (!objMarkets[u.k]) choixPossible.push(u);
                    })

                    let iKey = 0;
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                isnew: (!form.orderdepartment),
                                orderdepartment: form.orderdepartment,
                                rows: form.rows,
                                team: form.team,
                                // v: form.v,
                                options: {
                                    orderdepartment: choixPossible,
                                    groups: echangeur.wholesaleGroups,
                                },
                                errorSid: false,
                            }
                        },
                        components: {
                            "type-ahead": b2bTypeahead,
                        },
                        methods: {
                            deleteRow(i) {
                                this.rows.splice(i, 1);
                            },
                            close: function () {
                                ModalHelper.hide();
                            },
                            toOrderdepartment(k) {
                                const option = orderdepartment.find(u => (u.k == k));
                                return (option) ? option.v : k;
                            },
                            toGroup(k) {
                                const sdoc = echangeur.wholesaleGroups.rows.find(u => (u.k == k));
                                return (sdoc) ? sdoc.v : k;
                            },
                            typeaheadRep() {
                                return async function (key) {
                                    const rows = await THIS.rest("b2b.brandname.typeaheadRep", { k: key, limit: 10 })
                                    return rows.map(u => (
                                        { k: u.k, initial: u.initial, title: u.title, displayname: u.displayname, email: u.email, v: u.displayname + " (" + u.email + ")" }
                                    ));
                                }
                            },
                            selectuser(item) {
                                let exists = this.rows.find(u => (u.k == item.k));
                                if (!exists) {
                                    $$dic.addUtilisateur({ k: item.k, initial: item.initial, title: item.title, v: item.displayname, email: item.email })
                                    this.rows.push({ k: item.k, initial: item.initial, title: item.title, v: item.displayname, email: item.email, key: "key" + iKey++ })
                                }
                            },

                            async saveForm(e) {
                                e.preventDefault();
                                let nbError = 0;

                                this.errorSid = false;
                                if (!this.orderdepartment) {
                                    this.errorSid = true;
                                    nbError++;
                                }

                                if (!nbError) {
                                    const data = {
                                        orderdepartment: this.orderdepartment,
                                        reps: this.rows.map(u => u.k),
                                        team: this.team,
                                    }
                                    const result = await THIS.rest("b2b.brandname.saveOrderdepartmentsReps", { _id, orderdepartment: this.orderdepartment }, data);
                                    thisParent.saisie = result.doc;
                                    this.close();
                                }

                            },
                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlBrandnameReps).container);
                },


            },

        });

        this.vm = app.mount(THIS.c$('._vueChargement')[0]);

    },
    reprise: async function (ecran, echangeur) {

        // const form = await this.rest('b2b.toc.edit', echangeur.hash);

        //
        /* console.log(this.vm.$data) */
        // this.vm.$data.datas = form;
        //
        this.toggle(true);
        ecran.restaure();
        //


    }

});

export default {
    brandname: { js: js, html: html }
};



